/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isStringNotEmpty } from "utils/empty-exists";

/*
     TODO:
       - `hide` is used to hide the field from display.
       - in the schema (field) `hidden` mandates that we must set .hide = true, and that .hide can not be changed
       -   the toggle should operate on .hide and not operate on .hidden
       -   .hide is saved as part of the field settings in the model
       
     TODO:
       - `style` sets field text styling (many fields are essentially text) for display
       - in the schema (field) `defaultStyle` provides a default value - this can be prepopulated as `style` in the model
       - in the schema (field) `styleOptions` provides the style options to choose from

     TODO:
       - in the schema (field) `defaultValue` provides a default value - this can be prepopulated as the field "value"

     TODO:
       - in the schema (field) `noOverride` mandates that the field "value" must be populated using the defaultValue
          - and that `style` in the model must be populated using the defaultStyle

     TODO:
       - `format` is used to set the format a field
          - meaning to chose and set one of the presentation options.
          - for example: 1) a date format, or 2) show document title vs show document as a link
       - in the schema (field) `formatOptions` provides the format options to choose from
  */

const DisplayTextOnly = (props) => {
    
    const value = props?.value;
    const style = props?.style;
    const className = props?.className;
    
    // This display template ONLY needs to show 'style'.
    // defaultStyle should not be used with display. defaultStyle might be used to change 'style' only when editing
    const formattedStyle = style && style.length > 0 && style.replace("field.style.", "");
    
    return (
        <>
            {isStringNotEmpty(value) &&
                <p className={`display-field ${className} ${formattedStyle}`}>
                    {value}
                </p>
            }
        </>
    );
};
export default DisplayTextOnly;
